import { useInView } from 'react-intersection-observer';

import { DescriptionTopBanner } from '../components/DescriptionTopBanner';
import { useDescriptionTopBannerService } from '../services/useDescriptionTopBannerService';

export const DescriptionTopBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isHide, imageUrl, handleBannerClick, sendTopBannerImpressionUBL } = useDescriptionTopBannerService();
  const { ref } = useInView({
    onChange(inView) {
      if (inView) {
        sendTopBannerImpressionUBL?.();
      }
    },
    skip: typeof sendTopBannerImpressionUBL === 'undefined',
    threshold: 0.5,
  });

  if (isHide) {
    return null;
  }

  return (
    <div ref={ref}>
      <DescriptionTopBanner imageUrl={imageUrl} handleBannerClick={handleBannerClick} />
    </div>
  );
};
